export default __webpack_public_path__ + "static/media/route-planner-code-example.f5752c74.md";